{
  "tab": {
    "countries": "Countries",
    "regions": "Regions"
  },
  "button": {
    "viewAll": "View all destinations",
    "checkSupport": "Check support devices",
    "standard": "Standard",
    "dailyLimit": "Daily limit",
    "buy": "Buy",
    "continue": "Continue to payment",
    "loading": "Loading...",
    "stripe": "Pay Now",
    "backToHome": "Back to Home",
    "payNow": "Pay Now"
  },
  "nav": {
    "esimShop": "eSIM shop"
  },
  "checkout": {
    "title": "Secure Checkout",
    "section": {
      "package": "Order Summary"
    },
    "field": {
      "coverage": "Coverage",
      "traffic": "Traffic",
      "speed": "Speed",
      "validity": "Validity",
      "days": "Days",
      "total": "Total"
    },
    "payment": {
      "title": "Payment",
      "orPayWith": "Pay with PayPal",
      "secureEncrypted": "Your payments is 100% secure & encrypted"
    },
    "trust": {
      "instantDelivery": "Instant eSIM delivery via email/QR code right after payment",
      "moneyBack": "30-day Money Back Guarantee – Works or we refund",
      "support": "24/7 Support"
    }
  },
  "register": {
    "title": "Enter Your Email",
    "breadcrumb": "Your Email"
  },
  "profile": {
    "esimTitle": "eSIM {index}",
    "scanToInstall": "Scan to install",
    "field": {
      "iccid": "ICCID",
      "activationCode": "Activation Code"
    },
    "action": {
      "copy": "Copy",
      "copied": "Copied!"
    }
  },
  "search": {
    "placeholder": "Where are you traveling?",
    "destinations": "Destinations",
    "results": "Result",
    "resultsPlural": "Results",
    "noResults": "No destinations found",
    "country": "Country",
    "region": "Region",
    "esimPlan": "Search eSIM plan",
    "validation": {
      "selectCountryError": "Search for a country or region you are traveling to"
    }
  },
  "packages": {
    "deviceCompatibility": "Check Device Compatibility",
    "topUp": "If you run out of data, you can always <strong>top up</strong>",
    "packageStartNote": "Package starts when you connect to the supported network",
    "deviceRequirements": {
      "intro": "To use eSIM, your device must meet the following conditions:",
      "esimSupport": "The device supports eSIM.",
      "notLocked": "The device is not network-locked or carrier-locked."
    }
  }
}